// src/ChatBox.jsx
import React, { useEffect, useState, useRef } from 'react';
import { collection, addDoc, query, orderBy, onSnapshot, serverTimestamp } from 'firebase/firestore';
import { db } from './firebase';

const ChatBox = ({ itemId, currentUser }) => {
  const [messages, setMessages] = useState([]);
  const [msg, setMsg] = useState('');
  const messagesEndRef = useRef(null);

  // Fetch chat messages live
  useEffect(() => {
    if (!itemId) return;
    const q = query(
      collection(db, 'items', itemId, 'chat'),
      orderBy('timestamp', 'asc')
    );
    const unsub = onSnapshot(q, (snap) =>
      setMessages(snap.docs.map(doc => ({ id: doc.id, ...doc.data() })))
    );
    return () => unsub();
  }, [itemId]);

  // Scroll to bottom on new message
  useEffect(() => {
    if (messagesEndRef.current) {
      messagesEndRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  }, [messages]);

  // Handle sending message
  const handleSend = async (e) => {
    e.preventDefault();
    const trimmed = msg.trim();
    if (!trimmed) return;
    await addDoc(collection(db, 'items', itemId, 'chat'), {
      senderId: currentUser.uid,
      senderName: currentUser.displayName || currentUser.email || 'User',
      text: trimmed,
      timestamp: serverTimestamp()
    });
    setMsg('');
  };

  return (
    <div className="w-full max-w-xl mt-8 mx-auto bg-white rounded-2xl shadow p-6 flex flex-col gap-4">
      <div className="font-bold text-lg text-gray-700 mb-2">Chat with Founder/Claimer</div>
      <div className="flex-1 overflow-y-auto bg-gray-50 rounded-xl p-4" style={{ maxHeight: 200 }}>
        {messages.length === 0 ? (
          <div className="text-gray-400 text-center">No messages yet.</div>
        ) : (
          messages.map(m => (
            <div
              key={m.id}
              className={`mb-2 flex ${m.senderId === currentUser.uid ? 'justify-end' : 'justify-start'}`}
            >
              <div className={`inline-block px-3 py-2 rounded-lg ${m.senderId === currentUser.uid
                  ? 'bg-blue-100 text-blue-900'
                  : 'bg-gray-200 text-gray-800'
                }`}>
                <span className="font-semibold">{m.senderName}:</span>
                <span className="ml-2">{m.text}</span>
              </div>
            </div>
          ))
        )}
        <div ref={messagesEndRef} />
      </div>
      <form className="flex mt-2 gap-2" onSubmit={handleSend}>
        <div className="input flex flex-col w-fit relative">
  <label
    htmlFor="message"
    className="text-blue-500 text-xs font-semibold absolute -top-2 left-2 px-1 bg-[#e8e8e8] w-fit"
  >
    Message:
  </label>
  <input
    id="message"
    type="text"
    value={msg}
    onChange={e => setMsg(e.target.value)}
    placeholder="Type your message..."
    maxLength={500}
    autoComplete="off"
    className="border-blue-500 px-[10px] py-[11px] text-xs bg-[#e8e8e8] border-2 rounded-[5px] w-[210px] focus:outline-none placeholder:text-black/25 mt-3"
  />
</div>

       <button
  type="submit"
  disabled={!msg.trim()}
  className="relative cursor-pointer py-4 px-8 text-center font-barlow inline-flex justify-center text-base uppercase text-white bg-blue-700 rounded-lg border-solid transition-transform duration-300 ease-in-out group outline-offset-4 focus:outline-white focus:outline-offset-4 overflow-hidden disabled:opacity-50"
>
  <span className="relative z-20">Send</span>

  <span className="absolute left-[-75%] top-0 h-full w-[50%] bg-blue/20 rotate-12 z-10 blur-lg group-hover:left-[125%] transition-all duration-1000 ease-in-out" />

  <span className="w-1/2 drop-shadow-3xl transition-all duration-300 block border-blue absolute h-[20%] rounded-tl-lg border-l-2 border-t-2 top-0 left-0" />
  <span className="w-1/2 drop-shadow-3xl transition-all duration-300 block border-white absolute group-hover:h-[90%] h-[60%] rounded-tr-lg border-r-2 border-t-2 top-0 right-0" />
  <span className="w-1/2 drop-shadow-3xl transition-all duration-300 block border-white absolute h-[60%] group-hover:h-[90%] rounded-bl-lg border-l-2 border-b-2 left-0 bottom-0" />
  <span className="w-1/2 drop-shadow-3xl transition-all duration-300 block border-white absolute h-[20%] rounded-br-lg border-r-2 border-b-2 right-0 bottom-0" />
</button>

      </form>
    </div>
  );
};

export default ChatBox;
